export default "__VITE_ASSET__CvlK0U7m__"